const state = {
  vendorCategories: [],
};

export default state;
